const TextFieldHelperText = ({ children, ...props }) => {
  return (
    <div className="mdc-text-field-helper-line">
      <div className="mdc-text-field-helper-text" aria-hidden="true">
        {children}
      </div>
    </div>
  );
};

export default TextFieldHelperText;
